var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/gallery"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.03463 19.0103L3.0156 19.0303C2.75863 18.4403 2.59683 17.7703 2.53021 17.0303C2.59683 17.7603 2.77766 18.4203 3.03463 19.0103Z",
    fill: "#0161BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.14477 10.3801C10.3958 10.3801 11.4099 9.31456 11.4099 8.00012C11.4099 6.68568 10.3958 5.62012 9.14477 5.62012C7.89377 5.62012 6.87964 6.68568 6.87964 8.00012C6.87964 9.31456 7.89377 10.3801 9.14477 10.3801Z",
    fill: "#0161BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9877 2H8.01218C4.54787 2 2.4826 4.17 2.4826 7.81V16.19C2.4826 17.28 2.66343 18.23 3.01558 19.03C3.83407 20.93 5.58526 22 8.01218 22H15.9877C19.452 22 21.5173 19.83 21.5173 16.19V13.9V7.81C21.5173 4.17 19.452 2 15.9877 2ZM19.966 12.5C19.2236 11.83 18.0244 11.83 17.2821 12.5L13.3229 16.07C12.5805 16.74 11.3813 16.74 10.639 16.07L10.3154 15.79C9.63964 15.17 8.56419 15.11 7.8028 15.65L4.24331 18.16C4.03393 17.6 3.91021 16.95 3.91021 16.19V7.81C3.91021 4.99 5.32829 3.5 8.01218 3.5H15.9877C18.6716 3.5 20.0897 4.99 20.0897 7.81V12.61L19.966 12.5Z",
    fill: "#0161BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.10f5aedf71a30df0a8d700fef9964c66.svg";
export { ForwardRef as ReactComponent };